<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Plano</th>
          <th>Especialidade</th>
          <th>TOTAL</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="valor in valores" :key="valor._id">
          <td>{{ caixaAlta(valor.plano) }}</td>
          <td>{{ valor.especialidade }}</td>
          <td>{{ valor.quantidade }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import * as formatadores from '@/utils/formatadores'

export default {
  name: 'AtendimentoPlanoTabela',
  props: {
    valores: {
      type: Array,
      required: true,
    },
  },
  methods: {
    ...formatadores,
  },
}
</script>
